export const style = {
  list: {
    margin: 0,
    padding: 0,
    listStyle: `none`,
    fontSize: `12px`
  },
  listItem: {
    display: `block`,
    ':after': {
      color: `#ccc`,
      padding: `0 5px`,
      content: '"/"'
    }
  },
  link: {
    fontSize: `12px`,
    fontWeight: 400,
    color: `#a94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/partials/Sitemap/style/list.js